import styled, {useTheme} from "styled-components";
import React, {useMemo, useState} from "react";
import {FlexBox, MarginBox} from "../ui/styled";
import {defaultEmptyArray} from "../../function";

const OverviewWrapper = styled.div`
  background-color: ${props => props.theme.color.site_main_color};
  border-radius: 6px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 16px;
`;
const HeadBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  background-color: ${props => props.theme.color.white_200};
  padding: 5px 0 5px 16px;
`;
const TitleBox = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: ${props => props.theme.color.dark_100};
  margin-left: 4px;
`;
const BaseContentBox = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${props => props.theme.color.default_border_color};
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;
const ContentBox = styled(BaseContentBox)`
  padding: 16px 7px;
`;
const FinalContentBox = styled(BaseContentBox)`
  height: 208px;
  padding: 16px 12px;
`;
const SLLTextWrapper = styled.div`
  margin-left: 8px;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 12px;
`;

const LoserBracketAbsolute = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 11px;
`;
const FinalBracketAbsolute = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  position: absolute;
  left: 28.5px;
  bottom: 16px;
`;
const LogoBox = styled.div`
  margin-right: 25px;
`;
const FinalLogoBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const GroupText = styled.div`
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 18px;
  color: ${props => props.theme.color.dark_200};
  margin-top: 6px;
`;

const FinalGroupText = styled.div`
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 18px;
  color: ${props => props.theme.color.dark_200};
  margin-left: 8px;
`;

const BoundAbsolute = styled.div`
  z-index: 2;
  border-radius: 6px;
  position: absolute;
  right: 10px;
  top: 69px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid ${props => props.theme.color.green_100};
  background: ${props => props.theme.color.green_200};
  padding: 9px 6.4px 15px 6.5px;
  height: 200px;
`;

const BracketText = styled.div`
  text-align: center;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 14px;
  text-transform: uppercase;
  white-space: pre-wrap;
  color: ${props => props.theme.color.green_100};
`;

const MiddleConnector = styled.div`
  width: 1px;
  height: ${props => {
    let height = '15.5px'
    if (props.midConHeight) {
      height = props.midConHeight
    }
    return height
  }};
  background-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }};;
`;
const LastConnector = styled.div`
  width: ${props => props.width};
  height: 1px;
  background-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }};
`;
const TeamColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
const UpperTeamFlex = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  & + & {
    margin-top: 11px;
  }
`;


const FinalTeamFlex = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;

  & + & {
    margin-top: 16px;
  }
`;


const TeamWithLine = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;




`;


const LoserTeamColumn = styled.div`
  ${TeamWithLine} + ${TeamWithLine} {
    margin-top: 40px;
  }
`;
const FinalTeamColumn = styled.div`
  ${TeamWithLine} + ${TeamWithLine} {
    margin-top: 16px;
  }
`;


const LoserFinal = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  top: -16px;
`;


const ChartTeamWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => {
    let color = props.theme.color.white_200;
    if (props.isWin) {
      color = props.theme.color.white_100;
    }
    return color;
  }};
  padding: 0 0 0 8px;
  width: ${props => props.width || '96px'};
  height: 24px;
  border-width: 0.5px 4px 0.5px 0.5px;
  border-style: solid;
  border-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }}
`;

const TeamText = styled.span`
  font-weight: 600;
  font-size: 12px;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${props => {
    let color = props.theme.color.theme === 'dark' ? '#B2B2C2' : '#C3D1DC'
    if (props.isWin === 'win') {
      color = props.theme.color.dark_100
    } else if (props.isWin === 'lose') {
      color = props.theme.color.theme === 'dark' ? '#666666' : '#C3D1DC'
    } else if (props.hasTeam) {
      color = props.theme.color.dark_100
    }

    return color
  }};
`;
const TeamConnectorLine = styled.div`
  width: ${props => props.conWidth};
  height: 1px;
  background-color: ${props => {
    let color = props.theme.color.dark_300;
    if (props.isWin) {
      color = props.theme.color.green_100;
    }
    return color;
  }};
`;

const MiddleConnectorAbsolute = styled.div`
  position: absolute;
  ${props => {
    if (props.isBottom) {
      return `bottom:0`
    }
    return 'top:0'
  }};
  right: 0;
  z-index: ${props => {
    let zIndex = '0';
    if (props.isWin) {
      zIndex = '1';
    }
    return zIndex
  }}
`;
const LineBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`

const TeamLittleSpan = styled.span`
  font-weight: 400;
  font-size: 10px;
  color: ${props => props.theme.color.dark_300};
  margin-left: 2px;
`;

const SelectListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`;
const SelectItem = styled.button`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 96px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 12px;
  color: ${props => {
    let color = props.theme.color.theme === 'dark' ? '#666666' : '#C3D1DC';
    if (props.selected) {
      color = props.theme.color.dark_100
    }
    return color
  }};
`;
const SelectedBar = styled.div`
  position: absolute;
  bottom: -6px;
  height: 3px;
  width: 100%;
  background-color: ${props => props.theme.color.green_100};
  z-index: 2;
`;
const SelectBigText = styled.span`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 18px;
`;

const SelectFinalText = styled.span`
  font-weight: 700;
  font-size: 16px;
`;


const MangOverview = ({list, teamName}) => {
    const theme = useTheme();
    const [selectedGroup, setSelectedGroup] = useState('FINALS')

    const selectedData = useMemo(() => {
        try {
            const result = list[selectedGroup]
            if (result.length > 0) {
                return result
            }
            return []
        } catch (e) {
            return []
        }
    }, [selectedGroup]);

    return (
        <OverviewWrapper>
            <HeadBox>
                <FlexBox height={'auto'} justifyContent={'flex-start'}>
                    <img src={`images/sll/icon_sll_trophy.png`} alt={''} width={22} height={22}
                    />
                    <TitleBox>
                        결망전 토너먼트 대진표
                    </TitleBox>
                </FlexBox>
                <SelectListWrapper>
                    {/*<SelectItem onClick={() => setSelectedGroup('A')} selected={selectedGroup === 'A'}>*/}
                    {/*    <span>*/}
                    {/*    GROUP <SelectBigText>A</SelectBigText>*/}
                    {/*        </span>*/}
                    {/*    {selectedGroup === 'A' && <SelectedBar/>}*/}
                    {/*</SelectItem>*/}
                    {/*<SelectItem onClick={() => setSelectedGroup('FINALS')} selected={selectedGroup === 'FINALS'}>*/}
                    {/*    <SelectFinalText>*/}
                    {/*    FINALS*/}
                    {/*    </SelectFinalText>*/}
                    {/*    {selectedGroup === 'FINALS' && <SelectedBar/>}*/}
                    {/*</SelectItem>*/}
                    {/*<SelectItem onClick={() => setSelectedGroup('B')} selected={selectedGroup === 'B'}>*/}
                    {/*    <span>*/}
                    {/*    GROUP <SelectBigText>B</SelectBigText>*/}
                    {/*    </span>*/}
                    {/*    {selectedGroup === 'B' && <SelectedBar/>}*/}
                    {/*</SelectItem>*/}
                </SelectListWrapper>
            </HeadBox>
            {selectedData.length > 0 &&
                (selectedGroup === 'FINALS' ?
                    <ContentBox>
                        <GroupBracket groupData={selectedData} groupName={selectedGroup}/>
                    </ContentBox>
                    :
                    <FinalContentBox>
                        <FinalBracket groupData={selectedData}/>
                    </FinalContentBox>)
            }
        </OverviewWrapper>
    )
}

const Winner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 104px;
  padding: 0 6px;
  border: 1px solid ${props => props.theme.color.green_100};
  background: ${props => props.theme.color.green_200};
  border-radius: 6px;
`;

const WinnerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const SLLText = styled.span`
  text-align: center;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 20px;
`;
const CenterBox = styled.div`
    display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
`;
const FinalBracket = ({groupData}) => {
    const {isWin,} = useLeague({})
    const theme = useTheme()
    const winnerBracketFirstMatch = useMemo(() => groupData[0], [groupData])
    const winnerBracketSecondMatch = useMemo(() => groupData[1], [groupData])
    const winnerBracketLastMatch = useMemo(() => groupData[2], [groupData])

    const boundWinner = useMemo(() => {
        const winner = winnerBracketLastMatch.find((data) => data.isWin === 1);
        if (!winner) {
            return {team: "????", isWin: -1}
        }
        return winner
    }, [winnerBracketLastMatch]);

    return (
        <div>
            <FinalLeague matches={{
                first: winnerBracketFirstMatch,
                second: winnerBracketSecondMatch,
                last: winnerBracketLastMatch
            }}/>
            {/*<FinalBracketAbsolute>*/}
            {/*    <FinalLogoBox>*/}
            {/*        <img src={`${theme.icon.path}/sll/icon_sll_league.png`} alt={''}/>*/}
            {/*        <FinalGroupText>*/}
            {/*            FINALS*/}
            {/*        </FinalGroupText>*/}
            {/*    </FinalLogoBox>*/}
            {/*</FinalBracketAbsolute>*/}
            <Winner>
                <WinnerTextWrapper>

                    <SLLText>
                        결망전
                    </SLLText>
                    <BracketText>
                        WINNER
                    </BracketText>
                </WinnerTextWrapper>
                <ChartTeam isWin={'win'} team={boundWinner.team}
                           hasTeam={true} noCon={true}
                           isWinner={true}
                           width={'120px'}
                />
            </Winner>
        </div>
    )
}

const FinalLeague = ({matches}) => {
    const {calcHasTeam, findWhoWin, isFinishedMatch, isWin,} = useLeague({matches})

    const firstWinner = useMemo(() => findWhoWin(matches.first), [matches]);
    const secondWinner = useMemo(() => findWhoWin(matches.second), [matches]);


    return (
        <UpperTeamFlex>
            <TeamColumn>
                <FinalTeamFlex>
                    <FinalTeamColumn>
                        <ChartTeam isWin={isWin(matches.first[0]?.isWin)} team={matches.first[0].team}
                                   hasTeam={calcHasTeam(matches.first)} midConHeight={'25px'}
                                   conWidth={'31px'}
                        />
                        <ChartTeam isBottom={true} isWin={isWin(matches.first[1]?.isWin)} team={matches.first[1]?.team}
                                   hasTeam={calcHasTeam(matches.first)}
                                   midConHeight={'25px'}
                                   conWidth={'31px'}
                        />
                    </FinalTeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.first[0]?.isWin, matches.first[1]?.isWin)}
                                   width={'10px'}/>
                    <ChartTeam isWin={isWin(firstWinner.isWin)} midConHeight={'49px'}
                               team={firstWinner.team} hasTeam={calcHasTeam(matches.last)}
                               conWidth={'15px'}

                    />

                </FinalTeamFlex>

                <FinalTeamFlex>
                    <FinalTeamColumn>
                        <ChartTeam isWin={isWin(matches.second[0]?.isWin)} team={matches.second[0]?.team}
                                   hasTeam={calcHasTeam(matches.second)}
                                   midConHeight={'25px'}
                                   conWidth={'31px'}
                        />
                        <ChartTeam isBottom={true} isWin={isWin(matches.second[1]?.isWin)}
                                   team={matches.second[1]?.team}
                                   hasTeam={calcHasTeam(matches.second)}
                                   midConHeight={'25px'}
                                   conWidth={'31px'}
                        />
                    </FinalTeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.second[0]?.isWin, matches.second[1]?.isWin)}
                                   width={'10px'}/>
                    <ChartTeam isWin={isWin(secondWinner.isWin)} midConHeight={'49px'} isBottom={true}
                               team={secondWinner.team}
                               hasTeam={calcHasTeam(matches.last)}
                               conWidth={'15px'}
                    />
                </FinalTeamFlex>

            </TeamColumn>
            <LastConnector isWin={isFinishedMatch(matches.last[0]?.isWin, matches.last[1]?.isWin)}
                           width={'100px'}
            />
        </UpperTeamFlex>
    )
}


const WinnerRelative = styled.div`
  position: relative;
`;

const WinBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  top: 68px;
  right: 0;
`;
const GroupFinalWinner = styled.div`
  font-weight: 700;
  font-size: 12px;
  color: ${props => props.theme.color.dark_100};
  margin-top: 8px;
  margin-bottom: 4px;
`;
const GroupBracket = ({groupData, groupName}) => {
    const theme = useTheme()

    const winnerBracketFirstMatch = useMemo(() => defaultEmptyArray(groupData[0]), [groupData])
    const winnerBracketSecondMatch = useMemo(() => defaultEmptyArray(groupData[1]), [groupData])
    const winnerBracketLastMatch = useMemo(() => defaultEmptyArray(groupData[2]), [groupData])

    const loserBracketFirstMatch = useMemo(() => defaultEmptyArray(groupData[3]), [groupData])
    const loserBracketLastMatch = useMemo(() => defaultEmptyArray(groupData[4]), [groupData])

    const finalMatch = useMemo(() => defaultEmptyArray(groupData[5]), [groupData])

    const boundWinner = useMemo(() => {
        const winner = finalMatch?.[0];
        if (!winner) {
            return {team: "-", isWin: -1}
        }
        return winner
    }, [winnerBracketLastMatch]);
    const loserWinner = useMemo(() => {
        const winner = finalMatch?.[1];
        if (!winner) {
            return {team: "-", isWin: -1}
        }
        return winner
    }, [loserBracketLastMatch]);


    const finalWinner = useMemo(() => {
        const winner = finalMatch.find((data) => data.isWin === 1);
        if (!winner) {
            return {team: "-", isWin: false}
        }
        return winner
    }, [finalMatch])

    return (
        <WinnerRelative>
            <WinnerBracket matches={{
                first: winnerBracketFirstMatch,
                second: winnerBracketSecondMatch,
                last: winnerBracketLastMatch,
                winner: boundWinner,
            }}/>
            <LoserBracketAbsolute>
                {/*<WinnerBracket matches={{*/}
                {/*    first: winnerBracketFirstMatch,*/}
                {/*    second: winnerBracketSecondMatch,*/}
                {/*    last: winnerBracketLastMatch*/}
                {/*}}/>*/}
                {/*<LogoBox>*/}
                {/*    <img src={`${theme.icon.path}/sll/icon_sll_league.png`} alt={''}/>*/}
                {/*    <GroupText>*/}
                {/*        GROUP {groupName}*/}
                {/*    </GroupText>*/}
                {/*</LogoBox>*/}
                <LoserBracket matches={{
                    first: loserBracketFirstMatch,
                    last: loserBracketLastMatch,
                    winner: loserWinner,
                }}/>
            </LoserBracketAbsolute>
            <WinBox>
                <LastConnector isWin={finalWinner.isWin}
                               width={'7px'}/>
                <Winner>

                    <WinnerTextWrapper>
                        <CenterBox>
                            <SLLText>
                                결망전
                            </SLLText>
                            <BracketText>
                                WINNER
                            </BracketText>
                        </CenterBox>
                        <GroupFinalWinner>
                            {finalWinner?.team}
                        </GroupFinalWinner>
                        <div>
                            <img src={`images/sll/mgh_trophy.svg`} alt={''} width={18}
                            />
                        </div>
                    </WinnerTextWrapper>
                    {/*<ChartTeam isWin={'win'} team={boundWinner.team}*/}
                    {/*           hasTeam={true} noCon={true}*/}
                    {/*           isWinner={true}*/}
                    {/*           width={'120px'}*/}
                    {/*/>*/}
                </Winner>
            </WinBox>
        </WinnerRelative>
    )
}

const BracketRelative = styled.div`
  position: relative;
`;
const BracketAbsolute = styled.div`
  width: 119px;
  position: absolute;
  top: -19px;
  font-family: Archivo Black;
  font-weight: 400;
  font-size: 12px;
  color: #fff;
`;

const GrandFinalAbsolute = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 96px;
  position: absolute;
  height: 149px;
  font-weight: 600;
  font-size: 10px;
  color: ${props => props.theme.color.green_100};
`;
const WinnerBracket = ({matches}) => {
    const {calcHasTeam, findWhoWin, isFinishedMatch, isWin,} = useLeague({matches})

    const firstWinner = useMemo(() => findWhoWin(matches.first), [matches]);
    const secondWinner = useMemo(() => findWhoWin(matches.second), [matches]);

    return (
        <UpperTeamFlex>
            <TeamColumn>
                <UpperTeamFlex>
                    <TeamColumn>
                        <MarginBox margin={'0 0 5px 0'}>
                            <ChartTeam isWin={isWin(matches.first[0]?.isWin)} team={matches.first[0].team}
                                       hasTeam={calcHasTeam(matches.first)}/>
                        </MarginBox>
                        <ChartTeam isBottom={true} isWin={isWin(matches.first[1]?.isWin)} team={matches.first[1]?.team}
                                   hasTeam={calcHasTeam(matches.first)}
                        />
                    </TeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.first[0]?.isWin, matches.first[1]?.isWin)}
                                   width={'7px'}/>
                    <BracketRelative>
                        <ChartTeam isWin={isWin(firstWinner.isWin)} midConHeight={'33px'}
                                   team={firstWinner.team} hasTeam={calcHasTeam(matches.last)}
                        />
                    </BracketRelative>
                </UpperTeamFlex>

                <UpperTeamFlex>
                    <TeamColumn>
                        <MarginBox margin={'0 0 5px 0'}>
                            <ChartTeam isWin={isWin(matches.second[0]?.isWin)} team={matches.second[0]?.team}
                                       hasTeam={calcHasTeam(matches.second)}/>
                        </MarginBox>
                        <ChartTeam isBottom={true} isWin={isWin(matches.second[1]?.isWin)}
                                   team={matches.second[1]?.team}
                                   hasTeam={calcHasTeam(matches.second)}
                        />
                    </TeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.second[0]?.isWin, matches.second[1]?.isWin)}
                                   width={'7px'}/>
                    <ChartTeam isWin={isWin(secondWinner.isWin)} midConHeight={'33px'} isBottom={true}
                               team={secondWinner.team}
                               hasTeam={calcHasTeam(matches.last)}
                    />
                </UpperTeamFlex>

            </TeamColumn>
            <LastConnector isWin={isFinishedMatch(matches.last[0]?.isWin, matches.last[1]?.isWin)}
                           width={'7px'}
            />
            <BracketRelative>
                <GrandFinalAbsolute>
                    Grand Finals
                </GrandFinalAbsolute>
                <ChartTeam isWin={isWin(matches.winner?.isWin)} team={matches.winner?.team}
                           hasTeam={calcHasTeam(matches.winner)} midConHeight={'62.5px'}/>
            </BracketRelative>
        </UpperTeamFlex>
    )
}

const LoserBracket = ({matches}) => {
    const {isWin, isFinishedMatch, findWhoWin, calcHasTeam, findOtherPlayer} = useLeague({matches})


    const firstWinner = useMemo(() => findWhoWin(matches.first), [matches]);
    const otherWinner = useMemo(() => findOtherPlayer(firstWinner), [matches]);

    return (
        <UpperTeamFlex>
            <TeamColumn>
                <UpperTeamFlex>
                    <TeamColumn>
                        <MarginBox margin={'0 0 5px 0'}>
                            <ChartTeam isWin={isWin(matches.first[0]?.isWin)}
                                       team={matches.first[0]?.team} hasTeam={calcHasTeam(matches.first)}/>
                        </MarginBox>
                        <ChartTeam isBottom={true} isWin={isWin(matches.first[1]?.isWin)}
                                   team={matches.first[1]?.team} hasTeam={calcHasTeam(matches.first)}/>
                    </TeamColumn>
                    <LastConnector isWin={isFinishedMatch(matches.first[0]?.isWin, matches.first[1]?.isWin)}
                                   width={'7px'}/>
                    <MarginBox margin={'29px 0 0 0'}>
                        <UpperTeamFlex>

                            <TeamColumn>
                                <MarginBox margin={'0 0 5px 0'}>
                                    <ChartTeam team={otherWinner.team}
                                               isWin={isWin(otherWinner.isWin)} hasTeam={calcHasTeam(matches.last)}
                                    />
                                </MarginBox>
                                <ChartTeam team={firstWinner.team}
                                           isWin={isWin(firstWinner.isWin)} hasTeam={calcHasTeam(matches.last)}
                                           isBottom={true}/>

                            </TeamColumn>
                            <LastConnector isWin={isFinishedMatch(matches.last[0]?.isWin, matches.last[1]?.isWin)}
                                           width={'7px'}/>
                            <ChartTeam isWin={isWin(matches.winner?.isWin)} isBottom={true} midConHeight={'63.5px'}
                                       team={matches.winner?.team} hasTeam={calcHasTeam(matches.winner)}/>
                        </UpperTeamFlex>
                    </MarginBox>
                </UpperTeamFlex>
            </TeamColumn>

            {/*<LastConnector isWin={true} width={'60x'}/>*/}
        </UpperTeamFlex>
    )
}

const ChartTeam = ({team, isWin, isBottom, noCon, hasTeam, midConHeight, conWidth, isWinner, width}) => {
    return (
        <TeamWithLine>
            <ChartTeamWrapper isWin={isWin === 'win'} width={width}>
                {isWinner &&
                    <MarginBox margin={'0 8px 0 0'}>
                        <img src={'/images/ico_best_player01.svg'}/>
                    </MarginBox>
                }
                <TeamText isWin={isWin} hasTeam={hasTeam}>{team}</TeamText>
                <TeamLittleSpan isWin={isWin} hasTeam={hasTeam}>
                    팀
                </TeamLittleSpan>
            </ChartTeamWrapper>
            {!noCon &&
                <LineBox>
                    <TeamConnectorLine isWin={isWin === 'win'} conWidth={conWidth || '8px'}/>
                    <MiddleConnectorAbsolute isBottom={isBottom} isWin={isWin === 'win'}>
                        <MiddleConnector isWin={isWin === 'win'} midConHeight={midConHeight}/>
                    </MiddleConnectorAbsolute>
                </LineBox>
            }
        </TeamWithLine>
    )
}


const useLeague = ({matches}) => {
    const isWin = (value) => {
        if (value === 0) {
            return 'lose'
        } else if (value === 1) {
            return 'win'
        } else if (value === -1) {
            return 'none'
        }
    }

    const isFinishedMatch = (value1, value2) => {
        if (value1 >= 0 || value2 >= 0) {
            return true
        } else {
            return false
        }
    }

    const findWhoWin = (match) => {
        const winner = match.find((data) => data.isWin === 1);
        if (!winner) {
            return {team: "-", isWin: -1}
        }
        const lastWinner = matches.last.find((data) => winner.team === data.team);
        if (!lastWinner) {
            return {team: "-", isWin: -1}
        }
        return lastWinner
    }
    const calcHasTeam = (team) => {
        if (!team[0]?.team) {
            return false
        }
        if (team[0].team !== '-' || team[1].team !== '-') {
            return true
        }
        return false
    }
    const findOtherPlayer = (winner) => {
        if (!winner) {
            return {team: "-", isWin: -1}
        }
        const lastWinner = matches.last.find((data) => winner.team !== data.team);
        if (!lastWinner) {
            return {team: "-", isWin: -1}
        }
        return lastWinner
    }
    return {
        calcHasTeam,
        findWhoWin,
        isFinishedMatch,
        isWin,
        findOtherPlayer
    }
}


export default MangOverview